import UrlPattern from 'url-pattern';
import counterpart from 'counterpart';
import qs from 'qs';

import { getToken } from 'utils/token';
import * as dictionaries from 'constants/dictionaries';

const construct = (url, version = 'v2') => new UrlPattern('(*)' + '/' + version + url);

export const BASE_URL = '/SupportSrv/SupportSrv.svc/Support';

export const USER = construct('/user/current/ext');
export const COMPANY_INFO = construct('/ext/login/info');
export const LOGIN = construct('/login/:type');
export const RECOVERY = construct('/ext/password/reset');
export const RESET = construct('/ext/password/change');
export const PASSWORD_CHECK = construct('/ext/password/check');
export const SUBSCRIBE_NOTIFICATION = construct('/notification/subscribe');
export const UNSUBSCRIBE_NOTIFICATION = construct('/notification/unsubscribe');
export const NOTIFICATION_OPTIONS = construct('/notification/options');

export const CHANGE_USER_PASSWORD = construct('/ext/session/password/change');
export const PROJECT = construct('/project/:id');
export const PERSON = construct('/person/:id');
export const PROJECT_MASS = construct('/project/mass/:userId/detail/:prjId');

export const PERSON_STATE = construct('/menu/:projectId/people/:personId');
export const PERSON_WHO_STATE = construct('/project/:projectId/whoemployed/:personId');
export const CHANGE_PERSON_STATE = construct('/menu/people/state');

export const APPROVAL_PROJECT_LIST = construct('/approval/project');
export const APPROVAL_PROJECT = construct('/approval/project/:id');
export const APPROVAL_PROJECT_COUNTERS = construct('/approval/project/counters');
export const APPROVE_PROJECT = construct('/approval/project/:id/approve');
export const REJECT_PROJECT = construct('/approval/project/:id/reject');

export const APPROVAL_PERSON_LIST = construct('/approval');
export const APPROVAL_PERSON = construct('/approval/:id');
export const APPROVAL_PERSON_COUNTERS = construct('/approval/counters');
export const APPROVE_PERSON = construct('/approval/:id/approve');
export const REJECT_PERSON = construct('/approval/:id/reject');

export const PROJECT_LIST_SETTINGS = construct('/settings/project');
export const WORKSHEET_LIST_SETTINGS = construct('/settings/worksheet');
export const PROJECT_MASS_LIST_SETTINGS = construct('/settings/project/mass');
export const WORKSHEET_MASS_LIST_SETTINGS = construct('/settings/worksheet/mass');

export const PROJECT_LIST = construct('/person/:id/project');
export const WORKSHEET_LIST = construct('/project/:id/worksheet');
export const PROJECT_MASS_LIST = construct('/project/mass');
export const WORKSHEET_MASS_LIST = construct('/project/mass/:id');

export const RESPONSIBLE_USERS_DICT = construct('/dictionary/responsible');
export const COEXECUTIVE_USERS = construct('/user/coexecutive');
export const RESPONSIBLE_USERS = construct('/user/responsible');

export const REQUEST_SETTINGS = construct('/kadrsyst/settings', 'v1');
export const REQUEST_DOCUMENT = construct('/request/document');
export const REQUEST = construct('/project/request/:id');
export const REQUEST_LIST = construct('/project/request');
export const REQUEST_COUNTERS = construct('/project/request/counters');

export const MENU_COUNTERS = construct('/counters');
export const DOCUMENT_INFO = construct('/storage/:place/document/:id');
export const DOCUMENT = construct('/storage/:place/document/:id/body');
export const DOCUMENT_METRO = construct('/metro/storage/:place/document/:id/body', 'v1');
export const DOCUMENT_TEXT = construct('/document/:id/edit/text');
export const DOCUMENT_XML = construct('/document/:id/edit/xml');
export const FILE = construct('/storage/:place/document/:id/file');
export const METRO_FILE = construct('/metro/storage/:place/document/:id/file', 'v1');
export const XMHT = construct('/storage/:place/document/:id/body/index.html');

export const AVATAR = construct('/user/current/photo');

const getUrlToken = (path = 'SYS_token') => `?${path}=` + getToken();

export const generateMetroFileUrl = ({ docKeyInAnketaData : id, place = 3, metro }) => {
    return BASE_URL + METRO_FILE.stringify({ id, place }) + getUrlToken('token') + `&requestID=${metro}`;
};

export const generateFileUrl = ({ id, place = 3 }) => {
    return BASE_URL + FILE.stringify({ id, place }) + getUrlToken();
};

export const generateXMHTUrl = ({ id, place }) => {
    return BASE_URL + XMHT.stringify({ id, place }) + getUrlToken();
};

export const generateImageUrl = ({ id, place }) => {
    return BASE_URL + DOCUMENT.stringify({ id, place }) + getUrlToken();
};

export const generateMetroImageUrl = ({ docKeyInAnketaData : id, place, metro }) => {
    return BASE_URL + DOCUMENT_METRO.stringify({ id, place }) + getUrlToken('token') + `&requestID=${metro}`;
};

export const CANCEL_REQUEST = construct('/project/request/cancel');
export const ADD_REQUEST = construct('/project/request');
export const ORGANIZATIONS = construct('/organization');
export const DEPARTMENT = construct('/organization/:company/department');
export const LEGAL_ORGANIZATIONS = construct('/kadrsyst/legal', 'v1');
export const LEGAL_DEPARTMENT = construct('/kadrsyst/legal/:company/department', 'v1');
export const LEGAL_DEPARTMENT_CELLS = construct('/kadrsyst/department/:department/cell', 'v1');
export const REPLACING = construct('/organization/:organizationId/department/:departmentId/person');
export const EMPLOYEE = construct('/organization/:organizationId/employee');

export const TOWNS = construct('/ext/town');

export const MASS_STAGES = construct('/dictionary/stage/:id');

export const MASS_STAGE_MENU = construct('/menu/stage');
export const MASS_STAGE = construct('/menu/stage/state');

export const PROJECT_DICTIONARY_URL = construct('/project/dictionary/:type');
export const DICTIONARY_URL = construct('/dictionary/:type');
export const TYPE_URL = construct('/:type');
export const METRO_DICTIONARY_URL = construct('/metro/dictionary/:type', 'v1');
export const METRO_HR_DICTIONARY_URL = construct('/metro/hr/dictionary/:type', 'v1');
export const METRO_TOWN_DICTIONARY_URL = construct('/metro/town/dictionary', 'v1');
export const METRO_STORE_DICTIONARY_URL = construct('/metro/store/dictionary', 'v1');
export const METRO_UNIT_DICTIONARY_URL = construct('/metro/unit/dictionary', 'v1');
export const METRO_DIVISION_DICTIONARY_URL = construct('/metro/division/dictionary', 'v1');
export const METRO_CELL_DICTIONARY_URL = construct('/metro/cells/dictionary', 'v1');
export const METRO_POSITION_LEVELS = construct('/metro/poslevel/dictionary', 'v1');
export const METRO_DEPARTMENT_URL = construct('/metro/departments/dictionary/MetroDepartments', 'v1');
export const METRO_DEPARTMENT_CHILDREN_URL = construct('/metro/departments/dictionary/MetroDepartmentChildren', 'v1');

export const METRO_POSITION = construct('/metro/position/dictionary', 'v1');
export const METRO_CHIEF = construct('/metro/recruitingmanager', 'v1');
export const METRO_POSITION_DESCRIPTION = construct('/metro/position/description/:id', 'v1');
export const METRO_COST = construct('/metro/mvz/dictionary', 'v1');
export const METRO_FUNCTION = construct('/metro/departfunccode/dictionary', 'v1');
export const METRO_AUTH = construct('/metro/checknetlink', 'v1');

export const EVENT = construct('/event(/:id)');
export const EVENT_TYPES = construct('/event/types');
export const EVENT_DICTIONARIES = construct('/event/dictionaries');
export const EVENT_CONTACTS = construct('/event/contacts');
export const EVENT_COMPANIES = construct('/event/companies');
export const EVENT_PARTICIPANTS = construct('/event/participants');
export const EVENT_SCRIPT = construct('/event/script/:id');

export const EMAIL_APPROVAL = construct('/mail/object-status');

export const LINK_REGISTRATION = construct('/set-password');
export const GET_LOGIN_INFO = construct('/token/login-info');

export const GET_SCENARIO_AUTH = construct('/scenario/userlink');
export const GET_SCENARIO = construct('/scenario/data');
export const GET_SCENARIO_TEST = construct('/scenario/test');
export const SCENARIO_TEST = construct('/scenario/test');
export const TRAINER = construct('/action/trainer');
export const TRAINER_EVENTS = construct('/action/trainer');
export const GET_FILE_LIMITS = construct('/metro/limits', 'v1');

const addLang = (url, language, params = {}) => url + qs.stringify({
    [language || counterpart.getLocale()]: true,
    ...params
}, { addQueryPrefix: true });

export const getDictionaryUrl = ({ loadName, language, params }) => {
    let url;
    switch (loadName) {
        case dictionaries.budget:
        case dictionaries.education:
        case dictionaries.experience:
        case dictionaries.workplace:
        case dictionaries.worktype:
        case dictionaries.schedule:
        case dictionaries.reason:
        case dictionaries.sex:
        case dictionaries.yesno:
            url = PROJECT_DICTIONARY_URL.stringify({ type: loadName });
            break;
        case dictionaries.grossnet:
        case dictionaries.languageLevel:
        case dictionaries.mrktclienttype:
            url = DICTIONARY_URL.stringify({ type: loadName });
            break;
        case dictionaries.metroRegion:
        case dictionaries.metroDirectorats:
        case dictionaries.metroPositions:
        case dictionaries.metroOccupationType:
        case dictionaries.metroEmploymentType:
        case dictionaries.metroChartOfWork:
        case dictionaries.metroGrades:
        case dictionaries.metroBonusSchema:
        case dictionaries.metroDirectorateDecision:
        case dictionaries.metroCompanyCar:
        case dictionaries.metroHQ:
        case dictionaries.metroBonusPercent:
        case dictionaries.yesnocombo:
        case dictionaries.metroCompetence:
        case dictionaries.metroUsers:
            url = METRO_DICTIONARY_URL.stringify({ type: loadName });
            break;
        case dictionaries.metroRecruiters:
        case dictionaries.metroHRGeneralist:
        case dictionaries.metroHRM:
        case dictionaries.metroHRBP:
        case dictionaries.metroHRBPOperations:
            url = METRO_HR_DICTIONARY_URL.stringify({ type: loadName });
            break;
        case dictionaries.metroTown:
            url = METRO_TOWN_DICTIONARY_URL.stringify();
            break;
        case dictionaries.metroStore:
            url = METRO_STORE_DICTIONARY_URL.stringify();
            break;
        case dictionaries.metroUnits:
            url = METRO_UNIT_DICTIONARY_URL.stringify();
            break;
        case dictionaries.metroDivision:
            url = METRO_DIVISION_DICTIONARY_URL.stringify();
            break;
        case dictionaries.metroCell:
            url = METRO_CELL_DICTIONARY_URL.stringify();
            break;
        case dictionaries.metroDepartment:
            url = METRO_DEPARTMENT_URL.stringify();
            break;
        case dictionaries.metroDepartmentChildren:
            url = METRO_DEPARTMENT_CHILDREN_URL.stringify();
            break;
        case dictionaries.metroPositionLevels:
            url = METRO_POSITION_LEVELS.stringify();
            break;
        case dictionaries.limits:
            url = GET_FILE_LIMITS.stringify();
            break;
        default:
            url = TYPE_URL.stringify({ type: loadName });
    }

    return addLang(url, language, params);
};

export const GET_CALENDAR = construct('/calendar(/:userId)');
export const GET_CALENDAR_USERS = construct('/calendar/users');
export const CALENDAR_EVENT = construct('/calendar/event(/:id)');
export const CALENDAR_TASK = construct('/calendar/task(/:id)');

export const GET_EDUCATION_TIMESHEET = construct('/timesheet');
export const TRAINER_MARKS = construct('/scenario/marks/:id');

export const NOTDONE_LIST = construct('/notdone');

export const COMPANY = construct('/company/:id');

export const ACTION_VACANCY_LIST = construct('/actionvacancy(/:id)');
export const APPLICATION_LIST = construct('/application(/:id)');
export const COURSES_LIST = construct('/course/person/:userId');
export const ACTION_LIST = construct('/action(/:id)');
export const APPROVAL_APPLICATION_LIST = construct('/action/application/list');
export const APPROVAL_APPLICATION_LIST_COUNTERS = construct('/action/application/count');
export const APPROVAL_APPLICATION = construct('/action/application');
export const CREATE_APPROVAL_APPLICATION = construct('/action/application/approval');

export const GET_COURSE = construct('/course(/:id)');

export const SCORM_PLAYER = construct('/scorm/player.html');

export const getScormLink = (token = getToken(), folder, cmd) => (
    `${SCORM_PLAYER.stringify()}?${qs.stringify({ token, folder, cmd })}`
);

export const ENROLL_COURSE = construct('/course/enroll');

export const GET_BOOK_FILE = construct('/library/book/:id/file');

export const SCENARIO_BOOK = construct('/library/book/:id');

export const SCENARIO_FILE_LIST = construct('/library/book/list');

export const generateBookFileUrl = (id, cmd, SYS_token) => {
    return BASE_URL + GET_BOOK_FILE.stringify({ id }) + '?' + qs.stringify({ cmd, SYS_token });
};

export const NEWS = construct('/news(/:id)');

export const METRO_REQUEST = construct('/metro/request(/:id)', 'v1');
export const METRO_REQUEST_ROUTE = construct('/metro/approval-route', 'v1');
export const METRO_DOCUMENT = construct('/metro/document', 'v1');
export const CREATE_METRO_REQUEST_APPROVAL = construct('/metro/request/approve/:id', 'v1');

export const METRO_DEPARTMENTS = construct('/metro/departments/dictionary/MetroDepartments', 'v1');
export const METRO_DEPARTMENT_CHILDREN = construct('/metro/departments/dictionary/MetroDepartmentChildren', 'v1');
